import { render, staticRenderFns } from "./CompetitorResearchIcon.vue?vue&type=template&id=74830e62"
import script from "./CompetitorResearchIcon.vue?vue&type=script&lang=js"
export * from "./CompetitorResearchIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports